import '@fortawesome/fontawesome-pro/css/all.css';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import 'antd/dist/reset.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { copsAuthenticatorConstants } from 'utils/app-configs';
import getCOPScookie from 'utils/cookies';
import { configureCopsAuthenticator } from 'utils/cops-authenticator';
import '../node_modules/react-grid-layout/css/styles.css';
import '../node_modules/react-resizable/css/styles.css';
import './assets/css/common.css';
import rootReducer from './reducers';
import Root from './root';
import configureStore from './store/configure-store';

const store = configureStore(rootReducer);

configureCopsAuthenticator({
  clientId: getCOPScookie('ClientId') || AUTH_CLIENTID,
  tenant: getCOPScookie('Tenant') || AUTH_TENANT,
  resourceUri: getCOPScookie('Audience') || AUTH_RESOURCE,
  oAuthVersion: copsAuthenticatorConstants.V2,
  scope: [`${getCOPScookie('ApplicationUri') || AUTH_APPLICATION_URI}/user_impersonation`],
});

const renderApp = (RootCmp) => {
  const root = createRoot(document.getElementById('root'));
  root.render(<RootCmp store={store} />);
};

const run = () => {
  const instrumentationKey = getCOPScookie('InstrumentationKey') || INSTRUMENTATION_KEY;
  if (instrumentationKey && __ENV__ !== 'DEV') {
    const appInsights = new ApplicationInsights({ config: { instrumentationKey } });
    appInsights.loadAppInsights();
    window.appInsights = appInsights;
  }

  if (module.hot) {
    // hot reload reducers
    module.hot.accept('./reducers', () => {
      store.replaceReducer(require('./reducers').default); // eslint-disable-line global-require
    });
    // hot reload component will trigger a console error:
    // Warning: [react-router] You cannot change <Router routes>; it will be ignored
    // you can include a regex to the console filter: ^((?!You cannot change \<Router routes\>).)*$
    module.hot.accept('./root', () => {
      renderApp(require('./root').default); // eslint-disable-line global-require
    });
  }

  renderApp(Root);
};

if (!window.Intl) {
  import(/* webpackChunkName: "polyfill-intl" */ 'intl').then(run);
} else {
  // no polyfill
  run();
}
